import {
	type LanguageResource,
	languageResourceBuilder,
	type OneParamLanguageResourceTemplate,
	type TwoParamsLanguageResourceTemplate,
} from "@ruter-as/web-components-and-tools";

interface OrderFormLanguageResource {
	inputs: {
		phone: string;
		verificationCode: string;
		companySelect: {
			label: string;
		};
		firstName: string;
		lastName: string;
		employeeNumber: string;
		startDate: string;
	};
	buttons: {
		submitPhone: string;
		submitVerifationCode: string;
		reset: string;
		resendCode: string;
		submitOrder: string;
		cancel: string;
	};
	errors: {
		quarantineError: TwoParamsLanguageResourceTemplate;
		duplicateEmployeeId: OneParamLanguageResourceTemplate;
		openTicketError: string;
		wrongVerificationCode: string;
	};
}

const orderFormLanguageResource: LanguageResource<OrderFormLanguageResource> = {
	nb: {
		inputs: {
			phone: "Telefonnummer",
			verificationCode: "Verifiseringskode",
			companySelect: {
				label: "Bedrift",
			},
			firstName: "Fornavn",
			lastName: "Etternavn",
			employeeNumber: "Ansattnummer",
			startDate: "Startdato (for bedriftsbillett)",
		},
		buttons: {
			submitPhone: "Send verifikasjonskode",
			submitVerifationCode: "Verifiser",
			reset: "Tilbakestill",
			resendCode: "Send kode på nytt",
			submitOrder: "Meld på",
			cancel: "Avbryt",
		},
		errors: {
			duplicateEmployeeId: languageResourceBuilder.oneParamTemplate(
				"$p1$ er i bruk på en eksisterende billett.",
			),
			quarantineError: languageResourceBuilder.twoParamTemplate(
				"Bestilling av ny billett ble avvist, fordi det finnes en billett på dette telefonnummeret med sluttdato $p1$. Det er ikke mulig å ha overlappende billetter, første mulige startdato er derfor $p2$.",
			),
			openTicketError:
				"Det eksisterer allerede en gyldig eller ventende billett på dette telefonnummeret.",
			wrongVerificationCode: "Feil kode",
		},
	},
};

export default orderFormLanguageResource;
